import { makeOfflineGamePolicy } from './game-offline'

/**
 * TYPEPATH — 화면 자판 위에 단어의 길을 그리는 퍼즐. **수집 0 오프라인 골격을 쓴다.**
 *
 * 다른 게임 넷(Snowback·Keywright·Bargainsmith·Plumbline)은 `game-ads.ts` 인데
 * 이 게임만 다른 이유는 사실이 실제로 갈라져서다 — `game/typepath/addons/` 에는
 * `cottonray` 심볼릭 링크뿐이고 admob·billing 애드온이 없다. 소스에 `Ads.`·`Iap.`·
 * HTTPRequest 호출이 한 건도 없고 INTERNET 권한도 안 잡는다.
 *
 * **광고나 결제를 붙이는 날 이 파일을 같은 커밋에서 `game-ads.ts` 로 갈아탄다**
 * (docs/privacy-policy.md §절대 규칙 2). 그때 policies.test.ts 의 광고 고지 목록에도
 * typepath 를 넣어야 한다 — 안 넣으면 골격이 되돌아가도 아무도 안 잡는다.
 */
export const TYPEPATH_POLICY = makeOfflineGamePolicy({
  slug: 'typepath',
  title: 'TYPEPATH Privacy Policy',
  name: 'TYPEPATH',
  storedOnDevice:
    'Your best score, the furthest room you have reached, how many runs you have finished, and your sound and music volume are the only things the app keeps.',
  effectiveDate: 'August 25, 2026',
  history: [
    'August 25, 2026 — established (structured on Article 30 of the Personal Information Protection Act). The game has no account, no server, no advertising SDK, and no payment feature, and it does not request network access',
  ],
})
